const optionsAE = [
  { value: "Not Defined", label: "Not Defined" },
  { value: "Air-gapped", label: "Air-gapped" },
  { value: "Local-network", label: "Local Network" },
  { value: "Internet", label: "Internet" },
];
const options = [
  { value: "Not Defined", label: "Not Defined" },
  { value: "High", label: "High" },
  { value: "Basic", label: "Basic" },
  { value: "None", label: "None" },
];

const AddAssetConfigInputs = [
  {
    key: 1,
    title: "",
    inputs: [
      {
        label: "Device Name",
        name: "deviceName",
        placeholder: "Select Device Name",
        options: "serverOpt",
      },
    ],
  },
  {
    key: 2,
    title: "Environment Metrics",
    inputs: [
      {
        label: "Confidentiality Requirements",
        name: "confidentialityRequirement",
        placeholder: "Select Confidentiality Requirements",
        options: "options",
        tooltipText: "Indicates the importance of data confidentiality. Each level reflects the potential adverse effect on your organization in case of a confidentiality breach."
      },
      {
        label: "Integrity Requirements",
        name: "integrityRequirement",
        placeholder: "Select Integrity Requirements",
        options: "options",
        tooltipText: "Indicates the criticality of data integrity. Each level reflects the potential impact of integrity loss on your organization."
      },
      {
        label: "Availability Requirements",
        name: "availabilityRequirement",
        placeholder: "Select Availability Requirements",
        options: "options",
        tooltipText: "Indicates the significance of asset availability. Each level reflects the potential adverse impact on your organization due to a availability loss."
      },
    ],
  },
  {
    key: 3,
    title: "Risk Score Metrics",
    inputs: [
      {
        label: "Exposure",
        name: "exposure",
        placeholder: "Select Exposure",
        options: "optionsAE",
        tooltipText: "Indicates asset network location & Internet Proximity"
      },
      {
        label: "Protection",
        name: "protectionMeasure",
        placeholder: "Select Protection",
        options: "options",
        tooltipText: "Indicates protection measures implemented to enhance the asset's defense against vulnerability exploitation"
      },
      {
        label: "Detection",
        name: "detectionMeasure",
        placeholder: "Select Detection",
        options: "options",
        tooltipText: "Indicates security measures implemented to identify and counteract vulnerability exploitation in the asset."
      },
      {
        label: "Distribution",
        name: "distribution",
        placeholder: "Select Distribution",
        options: "options",
        tooltipText: "Indicates the extend and reach of the attack surface associated with this asset."
      },
    ],
  },

];
export const AssetConfigurationObj = {
  optionsAE: optionsAE,
  options: options,
  inputs: AddAssetConfigInputs,
};
export const TRSSelect = [
  {
    label: "Exposure (AE)",
    name: "exposure",
    placeholder: "Select Exposure",
    options: optionsAE,
  },
  {
    label: "Detection Measure",
    name: "detectionMeasure",
    placeholder: "Select Detection Measure",
    options: options,
  },
  {
    label: "Protection Measure",
    name: "protectionMeasure",
    placeholder: "Select Protection Measure",
    options: options,
  },
  {
    label: "Distribution",
    name: "distribution",
    placeholder: "Select Distribution",
    options: options,
  },
];
export const CVSSelect = [
  {
    label: "Confidentiality Requirements",
    name: "CR",
    placeholder: "Select Confidentiality Requirements",
    options: options,
  },
  {
    label: "Integrity Requirements",
    name: "IR",
    placeholder: "Select Integrity Requirements",
    options: options,
  },
  {
    label: "Availability Requirements",
    name: "AR",
    placeholder: "Select Availability Requirements",
    options: options,
  },
];
export const mainData = [
  {
    title: "TRS Metrics",
    selectOPtions: TRSSelect,
    key: 1,
    labels: [
      {
        name: "Exposure (AE)",
        value: "Not Defined",
      },
      {
        name: "Detection Measure",
        value: "Basic",
      },
      {
        name: "Protection Measure",
        value: "High",
      },
      {
        name: "Distribution",
        value: "None",
      },
    ],
  },
  {
    title: "CVS Environment Metrics",
    selectOPtions: CVSSelect,
    key: 2,
    labels: [
      {
        name: "Confidentiality Requirements",
        value: "High",
      },
      {
        name: "Integrity Requirements",
        value: "Basic",
      },
      {
        name: "Availability Requirements",
        value: "None",
      },
    ],
  },
];

export const initialFormData = {
  deviceName: [],
  exposure: "",
  protectionMeasure: "",
  detectionMeasure: "",
  distribution: "",
  confidentialityRequirement: "",
  integrityRequirement: "",
  availabilityRequirement: "",
};
export const isInitialFormDataEmptyOrZero = (props) => {
  for (const key in props) {
    if (props.hasOwnProperty(key)) {
      const value = props[key];
      // Special handling for deviceName array
      if (key === 'deviceName') {
        if (!Array.isArray(value) || value.length === 0) {
          return true;
        }
      } else if (value === undefined || value === null || value === '' || value === 0) {
        return true;
      }
    }
  }
  return false;
};